import React from 'react';
import translate from '../../Translations/index';


const Notification = (props) => {

    return(
        <div className=""></div>
    );

}

export default Notification;